export default function () {
	document.addEventListener('DOMContentLoaded', () => {
		const elements = document.querySelectorAll<HTMLElement>('[data-bg-src]')
		if (!elements.length) return

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (!entry.isIntersecting) return
					const el = entry.target as HTMLElement
					const src = el.dataset.bgSrc
					if (src) {
						el.style.backgroundImage = `url(${src})`
						el.classList.add('bg-loaded')
					}
					observer.unobserve(el)
				})
			},
			{ rootMargin: '200px' },
		)

		elements.forEach((el) => observer.observe(el))
	})
}
